import React from "react";

// EA monogram mark — sharp geometric SVG. Renders in currentColor for reuse.
export const EALogo = ({ size = 48, className = "", strokeWidth = 6 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Svenska Invest EA"
  >
    {/* E */}
    <path
      d="M14 14 H58 M14 14 V106 M14 106 H58 M14 60 H50"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="square"
    />
    {/* A */}
    <path
      d="M66 106 L86 14 L106 106 M74 74 H98"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
    {/* subtle registration ticks */}
    <path d="M2 60 H8 M112 60 H118 M60 2 V8 M60 112 V118" stroke="currentColor" strokeOpacity="0.35" strokeWidth="2" />
  </svg>
);

export default EALogo;
